import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { TowerControl } from "lucide-react";

import { formatGameTime } from "../format/formatGameTime";
import { formatList } from "../format/formatList";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";
import { IconBadge } from "./IconBadge";

const TITLE = msg({
  id: "finding.killed_by_objective",
  message: "Killed by towers and troopers {count, plural, one {once} other {# times}}",
});

const DETAILS = msg({
  id: "finding.killed_by_objective.details",
  message: "Deaths at {times}. Do not dive under a tower without support.",
});

const SUMMARY = msg({ id: "finding.killed_by_objective.summary", message: "Deaths at {times}" });

// Игрока убивали башни, стражи и крипы.
export const KilledByObjective = ({ finding, variant }: FindingProps<"killed_by_objective">) => {
  const { i18n } = useLingui();
  const { deaths: count, death_times_s: timesS } = finding.params;
  const times = formatList(timesS.map(formatGameTime), i18n.locale);
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={<IconBadge icon={TowerControl} size={iconSize(variant)} />}
      title={i18n._({ ...TITLE, values: { count } })}
      details={i18n._({ ...DETAILS, values: { times } })}
      summary={i18n._({ ...SUMMARY, values: { times } })}
    />
  );
};
